import {
    CONFIRM_BOOKING,
    CONFIRM_BOOKING_SUCCESS,
    CONFIRM_BOOKING_FAILED,
    CLEAR_BOOKING
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, push, get, update } from "firebase/database";
import { Platform } from 'react-native';

export const clearBooking = () => (dispatch) => {
    dispatch({
        type: CLEAR_BOOKING,
        payload: null,
    });
}

export const addBooking = (bookingData) => async (dispatch) => {

    const {
        bookingRef,
        config,
        singleUserRef
    } = firebase;

    dispatch({
        type: CONFIRM_BOOKING,
        payload: bookingData,
    });

    const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    const reference = [...Array(6)].map(_ => c[~~(Math.random() * c.length)]).join('');

    let today;
    try {
        let res = await fetch(`https://${config.projectId}.web.app/getservertime`, { method: 'GET', headers: { 'Content-Type': 'application/json' } });
        const json = await res.json();
        if (json.time) {
            today = json.time;
        } else {
            today = new Date().getTime();
        }
    } catch (err) {
        today = new Date().getTime();
    }

    let pickUp = { lat: bookingData.pickup.coords.lat, lng: bookingData.pickup.coords.lng, add: bookingData.pickup.description };
    let drop = { lat: bookingData.drop.coords.lat, lng: bookingData.drop.coords.lng, add: bookingData.drop.description };

    let coords = [{ latitude: pickUp.lat, longitude: pickUp.lng }];
    if (bookingData.drop.waypointsStr) {
        bookingData.drop.waypointsStr.split("|").forEach((point) => {
            let lat = point.split(',')[0];
            let lng = point.split(',')[1];
            coords.push({ latitude: parseFloat(lat), longitude: parseFloat(lng) });
        });
    }
    coords.push({ latitude: drop.lat, longitude: drop.lng });

    var otp;
    if (bookingData.settings.otp_secure)
        otp = Math.floor(Math.random() * 90000) + 10000;
    else {
        otp = false;
    }

    // FIXED: Better booking creation for outstation category
    // For outstation category, we need to ensure proper status and driver assignment
    let bookingStatus = "PAYMENT_PENDING";
    if (bookingData.booking_type_admin || bookingData.payment_mode == 'cash' || bookingData.payment_mode == 'yappi' || bookingData.carDetails.hasBid) {
        bookingStatus = "NEW";
    }
    
    // For outstation category, if no drivers found, still create booking but with special handling
    if (bookingData.carDetails.category === 'outstation' && (!bookingData.requestedDrivers || Object.keys(bookingData.requestedDrivers).length === 0)) {
        console.log('⚠️ Outstation booking with no drivers found - creating booking anyway');
        bookingStatus = "NEW"; // Force NEW status for outstation even without drivers
    }
    
    let data = {
        category: bookingData.carDetails.category,
        currency: bookingData.userDetails.currency_code,
        country: bookingData.userDetails.country_code,
        hasBid: bookingData.carDetails.hasBid,
        carType: bookingData.carDetails.name,
        carImage: bookingData.carDetails.image,
        customer: bookingData.userDetails.uid,
        fleet_admin_comission: bookingData.carDetails.fleet_admin_fee ? bookingData.carDetails.fleet_admin_fee : null,
        commission_type: bookingData.carDetails.convenience_fee_type,
        commission_rate: bookingData.carDetails.convenience_fees,
        reference: reference,
        customer_email: bookingData.userDetails.email,
        customer_name: bookingData.userDetails.firstName + ' ' + bookingData.userDetails.lastName,
        customer_contact: bookingData.userDetails.mobile ? bookingData.userDetails.mobile : ' ',
        customer_token: bookingData.userDetails.pushToken ? bookingData.userDetails.pushToken : ' ',
        customer_image: bookingData.userDetails.profile_image ? bookingData.userDetails.profile_image : "",
        drop: drop,
        pickup: pickUp,
        estimate: bookingData.estimate.estimateFare,
        estimateDistance: bookingData.estimate.estimateDistance,
        distance: bookingData.estimate.estimateDistance,
        estimateTime: bookingData.estimate.estimateTime,
        status: bookingStatus,
        bookLater: bookingData.bookLater,
        tripdate: bookingData.bookLater ? bookingData.tripdate : today,
        bookingDate: today,
        otp: otp,
        booking_type_admin: bookingData.booking_type_admin,
        coords: coords,
        waypoints: bookingData.drop.waypoints ? bookingData.drop.waypoints : null,
        tripInstructions: bookingData.tripInstructions ? bookingData.tripInstructions : null,
        trip_cost: bookingData.estimate.estimateFare,
        convenience_fees: bookingData.estimate.convenience_fees,
        driver_share: (parseFloat(bookingData.estimate.estimateFare) - parseFloat(bookingData.estimate.convenience_fees)).toFixed(bookingData.settings.decimal),
        paymentPacket: bookingData.paymentPacket ? bookingData.paymentPacket : null,
        requestedDrivers: bookingData.requestedDrivers ? bookingData.requestedDrivers : null,
        driverEstimates: bookingData.driverEstimates ? bookingData.driverEstimates : null,
        ...bookingData.instructionData,
        payment_mode: bookingData.payment_mode,
        booking_from_web: bookingData.booking_from_web ? bookingData.booking_from_web : false,
        fleetadminrider: bookingData.fleetadminrider ? bookingData.fleetadminrider : null,
        fleetadmin: bookingData.fleetadmin ? bookingData.fleetadmin : null,
        bidPrice: bookingData.bidPrice ? bookingData.bidPrice : null,
        bidPriceData: bookingData.bidPriceData ? bookingData.bidPriceData : {},
        negotiations: bookingData.negotiations ? bookingData.negotiations : {}
    }

    push(bookingRef, data).then(async (res) => {
        var bookingKey = res.key;
        
        // ========================================
        // FEATURE A & B: MUTUALLY EXCLUSIVE
        // ========================================
        // Check admin configuration for automatic features
        try {
            // Import both getAdminConfiguration and getAvailableDrivers from adminQueueActions
            const { getAdminConfiguration, getAvailableDrivers } = await import('./adminQueueActions');
            const config = await getAdminConfiguration();
            
            // Debug admin configuration for auto assignment
            console.log('📊 Admin Configuration for booking:', bookingKey, {
                automaticAssignment: config?.automaticAssignment,
                automaticSearch: config?.automaticSearch,
                automaticNotification: config?.automaticNotification,
                autoAssignmentTimeout: config?.autoAssignmentTimeout || 30
            });
            
            // Get settings for driver radius (will be used later in timeout function)
            const settingsSnapshot = await get(firebase.settingsRef);
            const settings = settingsSnapshot.val() || {};
            console.log('📊 Settings for booking:', bookingKey, {
                driverRadius: settings.driverRadius || 10,
                decimal: settings.decimal || 2
            });

            if (data.status === 'NEW' && data.requestedDrivers && Object.keys(data.requestedDrivers).length > 0) {
                
                if (config && config.automaticAssignment) {
                    // ========================================
                    // FEATURE B: AUTOMATIC ASSIGNMENT WITH TIMEOUT
                    // ========================================
                    console.log('🚗 Feature B: Automatic assignment with timeout enabled for new booking:', bookingKey);
                    console.log('📍 Pickup location:', data.pickup);
                    
                    // ✅ NEW: Schedule auto assignment with timeout instead of immediate assignment
                    const timeoutSeconds = config.autoAssignmentTimeout || 30;
                    console.log(`⏰ Scheduling auto assignment in ${timeoutSeconds} seconds if no driver accepts...`);
                    
                    // Store reference to Firebase objects for use in timeout
                    const { singleBookingRef, singleUserRef, carAddRef, settingsRef } = firebase;
                    
                    // Verify Firebase references are available
                    console.log('🔍 Verifying Firebase references for timeout function:', {
                        hasSingleBookingRef: !!singleBookingRef,
                        hasSingleUserRef: !!singleUserRef,
                        hasCarAddRef: !!carAddRef,
                        hasSettingsRef: !!settingsRef
                    });
                    
                    // Schedule auto assignment with timeout
                    setTimeout(async () => {
                        try {
                            // Check if booking still needs driver assignment
                            const currentBookingSnapshot = await get(singleBookingRef(bookingKey));
                            
                            if (currentBookingSnapshot.exists()) {
                                const currentBooking = currentBookingSnapshot.val();
                                
                                // Only auto-assign if booking is still NEW and no driver assigned
                                if (currentBooking.status === 'NEW' && !currentBooking.driver) {
                                    console.log(`⏰ Timeout reached for booking ${bookingKey} - no driver accepted, auto-assigning nearest driver`);
                                    
                                    // Get available drivers for auto assignment using driverRadius from config
                                    // Note: driverRadius is now included in the config from getAdminConfiguration
                                    const driverRadius = config.driverRadius || 10;
                                    console.log('🔍 Auto Assignment: Using driverRadius from settings:', driverRadius, 'km');
                                    
                                    // Get available drivers for auto assignment
                                    const availableDrivers = await getAvailableDrivers(data.pickup, driverRadius);
                                    
                                    if (availableDrivers && availableDrivers.length > 0) {
                                        // Apply FIFO rule: assign to nearest available driver
                                        const nearestDriver = availableDrivers[0]; // Already sorted by distance
                                        console.log(`🎯 Auto-assigning nearest driver: ${nearestDriver.name || nearestDriver.id}`);
                                        
                                        // Assign driver to booking
                                        const assignmentResult = await assignDriverToNewBooking(bookingKey, nearestDriver, data);
                                        
                                        if (assignmentResult.success) {
                                            console.log('✅ Driver auto-assigned successfully after timeout');
                                            
                                            // Send notification to customer about driver assignment
                                            if (data.customer_token) {
                                                const { RequestPushMsg } = await import('../other/NotificationFunctions');
                                                RequestPushMsg(data.customer_token, {
                                                    title: 'Conductor asignado',
                                                    msg: `Un conductor ha sido asignado automáticamente a tu viaje después de ${timeoutSeconds} segundos`,
                                                    screen: 'BookedCab',
                                                    params: { bookingId: bookingKey },
                                                    channelId: 'general',
                                                    sound: 'general.mp3'
                                                });
                                                console.log('🔔 Customer notification sent: Driver assigned automatically after timeout');
                                            }
                                            
                                            // Send notification to driver about trip assignment using admin config
                                            if (nearestDriver.token) {
                                                // Get admin configuration for notification
                                                let notificationTitle = 'Viaje asignado';
                                                let notificationMessage = `Se te ha asignado automáticamente un nuevo viaje`;
                                                try {
                                                    const { getAdminConfiguration } = await import('./adminQueueActions');
                                                    const adminConfig = await getAdminConfiguration();
                                                    if (adminConfig) {
                                                        if (adminConfig.notificationTitle) {
                                                            notificationTitle = adminConfig.notificationTitle;
                                                        }
                                                        if (adminConfig.notificationMessage) {
                                                            notificationMessage = adminConfig.notificationMessage;
                                                        }
                                                        console.log('🔔 Using admin config for auto assignment notification:', { notificationTitle, notificationMessage });
                                                    }
                                                } catch (configError) {
                                                    console.log('⚠️ Could not load admin config for auto assignment, using default notification');
                                                }
                                                
                                                RequestPushMsg(nearestDriver.token, {
                                                    title: notificationTitle,
                                                    msg: notificationMessage,
                                                    screen: 'NewTrip',
                                                    params: { 
                                                        bookingId: bookingKey,
                                                        pickup: data.pickup,
                                                        destination: data.drop,
                                                        pickup_address: data.pickup.add,
                                                        destination_address: data.drop.add,
                                                        fare: data.estimate,
                                                        distance: data.distance,
                                                        duration: data.estimateTime
                                                    },
                                                    channelId: 'general',
                                                    sound: 'general.mp3'
                                                });
                                                console.log('🔔 Driver notification sent: Trip assigned automatically after timeout with admin config');
                                            }
                                        } else {
                                            console.log('❌ Automatic assignment after timeout failed:', assignmentResult.message);
                                        }
                                    } else {
                                        console.log('ℹ️ No available drivers found for automatic assignment after timeout');
                                    }
                                } else {
                                    console.log(`✅ Booking ${bookingKey} already has driver or status changed, skipping auto assignment`);
                                }
                            } else {
                                console.log(`⚠️ Booking ${bookingKey} no longer exists, skipping auto assignment`);
                            }
                        } catch (assignmentError) {
                            console.error('❌ Error in timeout auto assignment:', assignmentError);
                        }
                    }, timeoutSeconds * 1000); // Convert to milliseconds
                    
                    console.log(`✅ Auto assignment scheduled for booking ${bookingKey} in ${timeoutSeconds} seconds`);
                    
                } else if (config && config.automaticNotification) {
                    
                    if (bookingData.requestedDrivers) {
                        const drivers = bookingData.requestedDrivers;
                        Object.keys(drivers).map((uid) => {
                        //     onValue(singleUserRef(uid), snapshot => {
                        //         if (snapshot.val()) {
                        //             const pushToken = snapshot.val().pushToken;
                        //             const ios = snapshot.val().userPlatform == "IOS" ? true : false
                        //             if (pushToken) {
                        //                 RequestPushMsg(
                        //                     pushToken,
                        //                     {
                        //                         title: store.getState().languagedata.defaultLanguage.notification_title,
                        //                         msg: store.getState().languagedata.defaultLanguage.new_booking_notification,
                        //                         screen: 'DriverTrips',
                        //                         channelId: 'bookings-repeat', // Always use repeat channel for drivers
                        //                         ios: ios,
                        //                         sound: Platform.OS === 'android' ? 'repeat' : 'repeat.wav' // Correct format for each platform
                        //                     }
                        //                 );
                        //             }
                        //         }
                        //     }, { onlyOnce: true });
                            return drivers[uid];
                        })
                    }
                    
                } else {
                    // ========================================
                    // NO AUTOMATIC FEATURES ENABLED
                    // ========================================
                    console.log('ℹ️ No automatic features enabled for new booking:', bookingKey);
                    console.log('📋 Drivers will receive normal notifications (existing flow)');
                }
            }
            
        } catch (configError) {
            console.error('❌ Error checking admin configuration:', configError);
        }
        
        dispatch({
            type: CONFIRM_BOOKING_SUCCESS,
            payload: {
                booking_id: bookingKey,
                mainData: {
                    ...data,
                    id: bookingKey
                }
            }
        });
    }).catch(error => {
        dispatch({
            type: CONFIRM_BOOKING_FAILED,
            payload: error.code + ": " + error.message,
        });
    });
};

// Helper function to assign driver to new booking
const assignDriverToNewBooking = async (bookingId, driver, bookingData) => {
  try {
    // Check if firebase is initialized
    if (!firebase) {
      throw new Error('Firebase not initialized');
    }
    
    // Check if required references exist
    if (!firebase.carAddRef) {
      throw new Error('Firebase carAddRef not available');
    }
    
    const { singleBookingRef, singleUserRef, carAddRef } = firebase;
    
    // Get driver profile
    const driverSnapshot = await get(singleUserRef(driver.id));
    if (!driverSnapshot.exists()) {
      throw new Error('Driver profile not found');
    }
    
    const driverProfile = driverSnapshot.val();
    
    // Get driver's active car
    let carData = {};
    try {
      const carSnapshot = await get(carAddRef);
      if (carSnapshot.exists()) {
        const cars = carSnapshot.val();
        Object.keys(cars).forEach(carId => {
          const car = cars[carId];
          if (car.driver === driver.id && car.active) {
            carData = car;
          }
        });
      }
    } catch (carError) {
      console.log('⚠️ Error reading car data, using profile data:', carError);
    }
    
    // Calculate driver fee and commission
    const fleetCommission_fee = driverProfile.fleetadmin ? 
      ((parseFloat(bookingData.estimate) - parseFloat(bookingData.convenience_fees || 0)) * parseFloat(bookingData.fleet_admin_comission || 0) / 100).toFixed(2) : 0;
    const driver_fee = parseFloat(parseFloat(bookingData.estimate) - (parseFloat(bookingData.convenience_fees || 0) + parseFloat(fleetCommission_fee))).toFixed(2);
    
    // Prepare driver data for booking
    const driverData = {
      driver: driver.id,
      // Clear auto search related fields when driver is assigned
      autoSearchActive: null,
      autoSearchTimestamp: null,
      automaticSearch: null,
      cancelledBy: null,
      cardPaymentAmount: null,
      cashPaymentAmount: null,
      discount: null,
      dropAdress: null,
      id: null,
      pickupAddress: null,
      previousDriver: null,
      previousDriverToken: null,
      reason: null,
      wasAccepted: null,
      driver_name: driverProfile.firstName && driverProfile.lastName ? 
        `${driverProfile.firstName} ${driverProfile.lastName}` : driverProfile.name || 'Driver',
      driver_contact: driverProfile.mobile || '',
      driver_token: driverProfile.pushToken || '',
      driver_image: driverProfile.profile_image || '',
      car_image: carData.car_image || driverProfile.car_image || '',
      vehicle_number: carData.vehicleNumber || driverProfile.vehicleNumber || '',
      vehicleYear: carData.vehicleYear || driverProfile.vehicleYear || '',
      vehicleColor: carData.vehicleColor || driverProfile.vehicleColor || '',
      carType: carData.carType || driverProfile.carType || '',
      vehicleMake: carData.vehicleMake || driverProfile.vehicleMake || '',
      vehicleModel: carData.vehicleModel || driverProfile.vehicleModel || '',
      other_info: carData.other_info || driverProfile.other_info || '',
      driverRating: driverProfile.rating || '0',
      fleetadmin: driverProfile.fleetadmin || '',
      driver_share: driver_fee,
      fleetCommission: fleetCommission_fee,
      driverDeviceId: driverProfile.deviceId || '',
      status: 'ACCEPTED',
      requestedDrivers: null,
      driverEstimates: null,
      accepted_at: new Date().toISOString(),
      automatic_assignment: true,
      assignment_reason: 'Automatic assignment (Feature B)'
    };
    
    // Update booking with driver data
    await update(singleBookingRef(bookingId), driverData);
    
    // Update driver queue status
    await update(singleUserRef(driver.id), { queue: false });
    
    console.log('✅ Driver data updated in booking:', {
      driverId: driver.id,
      driverName: driverData.driver_name,
      status: driverData.status,
      automatic_assignment: driverData.automatic_assignment,
      assignment_reason: driverData.assignment_reason
    });
    
    return {
      success: true,
      message: 'Driver assigned successfully with automatic assignment',
      driver: driverData
    };
    
  } catch (error) {
    console.error('❌ Error assigning driver to new booking:', error);
    return {
      success: false,
      message: 'Failed to assign driver to new booking',
      error: error.message
    };
  }
};

